
import {
    Text,
    Flex
} from "@chakra-ui/react";

import { BankSlipIcon } from "../../../styles/icons/BankSlipIcon";
import { RightArrow } from "../../../styles/icons/RightArrow";
export function SectionReviewModal({ oldValue, newValue, nameSection }) {


    function GetTypes(type: string) {
        switch (type) {
            case "PERCENTAGE":
                return "Porcentagem"
            case "VALUE":
                return "Valor Fixo";
        }

    }

    function FormatValue(obj, organized) {

        const typeOld = String(obj?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType)
        const valueOld = String(obj?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.value)
        const typeNew = String(obj?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.paymentFeeType)
        const valueNew = String(obj?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.value)

        if (organized === "new") {
            if (typeNew === "PERCENTAGE") {
                return `${valueNew.replace("R$", "").replace("%", "")}%`
            }
            else {
                return `R$ ${valueNew.replace("R$", "").replace("%", "")}`
            }

        } else {
            if (typeOld === "PERCENTAGE") {
                return `${valueOld.replace("R$", "").replace("%", "")}%`
            }
            else {
                return `R$ ${valueOld.replace("R$", "").replace("%", "")}`
            }
        }



    }

    return (
        <Flex flexDir="column" gap="26px" >
            <Flex gap=".4rem" >
                <BankSlipIcon size={22} />
                <Text
                    fontSize="16px"
                    color="rgba(0, 0, 0, 1)"
                    fontWeight="600"
                    fontFamily="Hero New"
                    lineHeight="22.38px"

                >{nameSection}</Text>
            </Flex>
            <Flex
                gap="30px"
            >
                <Flex
                    flexDirection="column"
                    minW="200px"

                >
                    <Text
                        color={oldValue?.organizedRatesDayOld?.GLOBAL[0]?.day !== newValue?.organizedRatesDayNew?.GLOBAL[0]?.day ? "rgba(138, 148, 168, 1)" : "rgba(195, 202, 215, 1)"}
                        fontFamily="Hero New"
                        fontSize="12px"
                        lineHeight="16px"
                    >Tempo de repasse</Text>

                    {oldValue &&

                        <Flex
                            alignContent="center"
                            alignItems="center"
                            gap="8px"
                        >


                            {newValue && (oldValue?.organizedRatesDayOld?.GLOBAL[0]?.day !== newValue?.organizedRatesDayNew?.GLOBAL[0]?.day) ?
                                <>
                                    <Text
                                        color="#000000"
                                    >
                                        D + {oldValue?.organizedRatesDayOld?.GLOBAL[0]?.day}
                                    </Text>
                                    <RightArrow />
                                    <Text
                                        fontWeight="bold"
                                        color="rgba(212, 136, 6, 1)"
                                    >
                                        D + {newValue?.organizedRatesDayNew?.GLOBAL[0]?.day}
                                    </Text>
                                </> :
                                <Text
                                    fontSize="16px"
                                    color="rgba(195, 202, 215, 1)"
                                    lineHeight="26px"
                                    fontFamily="Hero New"
                                >
                                    D + {oldValue?.organizedRatesDayOld?.GLOBAL[0]?.day}
                                </Text>
                            }
                        </Flex>
                    }
                </Flex>
                <Flex
                    flexDirection="column"
                    minW="200px"


                >
                    <Text
                        color={oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.value !== newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.value ? "rgba(138, 148, 168, 1)" : "rgba(195, 202, 215, 1)"}
                        fontFamily="Hero New"
                        fontSize="12px"
                        lineHeight="16px"
                    >Taxa</Text>

                    {oldValue &&

                        <Flex
                            alignContent="center"
                            alignItems="center"
                            gap="8px"
                        >

                            {newValue && (oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.value !== newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.value) ?
                                <>
                                    <Text
                                        color="#000000"
                                    >
                                        {FormatValue(oldValue, "old")}

                                    </Text>
                                    <RightArrow />
                                    <Text
                                        fontWeight="bold"
                                        color="rgba(212, 136, 6, 1)"
                                    >
                                        {FormatValue(newValue, "new")}
                                    </Text>
                                </> :
                                <Text
                                    fontSize="16px"
                                    color="rgba(195, 202, 215, 1)"
                                    lineHeight="26px"
                                    fontFamily="Hero New"
                                >
                                    {FormatValue(oldValue, "old")}
                                </Text>
                            }
                        </Flex>

                    }
                </Flex>
                <Flex
                    flexDirection="column"
                    minW="200px"

                >
                    <Text
                        color={oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.rateLimitValue !== newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.rateLimitValue ? "rgba(138, 148, 168, 1)" : "rgba(195, 202, 215, 1)"}
                        fontFamily="Hero New"
                        fontSize="12px"
                        lineHeight="16px"
                    >Limite</Text>

                    {oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.rateLimitValue &&
                        <Flex
                            alignContent="center"
                            alignItems="center"
                            gap="8px"
                        >

                            {newValue && (oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.rateLimitValue !== newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.rateLimitValue) ?
                                <>
                                    <Text
                                        color="#000000"
                                    >

                                        {(oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType === "VALUE" || oldValue?.organizedRatesOld?.GLOBAL[0]?.paymentMethods?.name === "PIX") &&
                                            oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.rateLimitValue.toLocaleString("pt-BR", {
                                                style: "currency", currency: "BRL", minimumFractionDigits: 2
                                            })
                                        }

                                        {(oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType === "PERCENTAGE" && oldValue?.organizedRatesOld?.GLOBAL[0]?.paymentMethods?.name === "BANK_SLIP") &&
                                            `${oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.rateLimitValue}%`
                                        }
                                    </Text>
                                    <RightArrow />

                                    <Text
                                        fontWeight="bold"
                                        color="rgba(212, 136, 6, 1)"
                                    >

                                        {newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.rateLimitValue &&
                                            newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.rateLimitValue.toLocaleString("pt-BR", {
                                                style: "currency", currency: "BRL", minimumFractionDigits: 2
                                            })
                                        }

                                     
                                    </Text>
                                </> :
                                <Text
                                    fontSize="16px"
                                    color="rgba(195, 202, 215, 1)"
                                    lineHeight="26px"
                                    fontFamily="Hero New"

                                >
                                    {(oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType === "VALUE" || oldValue?.organizedRatesOld?.GLOBAL[0]?.paymentMethods?.name === "PIX") &&
                                        oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.rateLimitValue.toLocaleString("pt-BR", {
                                            style: "currency", currency: "BRL", minimumFractionDigits: 2
                                        })
                                    }

                                    {(oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType === "PERCENTAGE" && oldValue?.organizedRatesOld?.GLOBAL[0]?.paymentMethods?.name === "BANK_SLIP") &&
                                        `${oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.rateLimitValue}%`
                                    }
                                </Text>
                            }


                        </Flex>
                    }
                </Flex>

                {nameSection === "Boleto" &&
                    <Flex
                        flexDirection="column"

                    >

                        <Text
                            color={oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType !== newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.paymentFeeType ? "rgba(138, 148, 168, 1)" : "rgba(195, 202, 215, 1)"}
                            fontFamily="Hero New"
                            fontSize="12px"
                            lineHeight="16px"
                        >Tipo de taxa</Text>

                        {oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType &&
                            <Flex
                                alignContent="center"
                                alignItems="center"
                                gap="8px"
                            >

                                {newValue && (oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType !== newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.paymentFeeType) ?
                                    <>
                                        <Text
                                            color="#000000"
                                        >
                                            {GetTypes(oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType)}
                                        </Text>
                                        <RightArrow />

                                        <Text
                                            fontWeight="bold"
                                            color="rgba(212, 136, 6, 1)"
                                        >
                                            {GetTypes(newValue?.organizedRatesNew?.GLOBAL[0]?.installments[0]?.paymentFeeType)}
                                        </Text>
                                    </> :
                                    <Text
                                        fontSize="16px"
                                        color="rgba(195, 202, 215, 1)"
                                        lineHeight="26px"
                                        fontFamily="Hero New"

                                    >
                                        {GetTypes(oldValue?.organizedRatesOld?.GLOBAL[0]?.installments[0]?.paymentFeeType)}
                                    </Text>
                                }


                            </Flex>
                        }
                    </Flex>}
            </Flex>
        </Flex >
    )

}